<template>
  <div class="card">
    <div class="card-header">
      Week 23.05.2018 - 31.06.18
    </div>
    <div class="card-body">
      Hausuafgabe 02
    </div>
  </div>
</template>

<script>
export default {
  name: "courseweek"
}
</script>

<style lang="scss" scoped>
.card {
  width: 80%;
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Course/CourseWeek.vue